import { SkeletonProps } from 'antd'
import { FunctionComponent, ReactNode } from 'react'
import Blur from '@/components/common/blur'
import KolDetailStatistic from '@/components/kol/common/kol-detail-statistic'
import { Percentage } from '@/components/kol/detail/audience-analyses/audience-analysis'
import { useIntl } from '@/i18n/hooks/use-intl'
import { KpiSchema } from '@/types/schema/kpi-schema'

const FAKE_MAIN_GENDER = 0.76

interface AudienceGenderStatisticProps {
  kpi?: KpiSchema
  isKolInfoLocked: boolean
  showMockData?: boolean
  statisticLoading: SkeletonProps | boolean
}

const AudienceGenderStatistic: FunctionComponent<
  AudienceGenderStatisticProps
> = ({ kpi, isKolInfoLocked, showMockData, statisticLoading }) => {
  const { formatMessage, formatNumber } = useIntl()

  return (
    <KolDetailStatistic
      loading={statisticLoading}
      suffix={((): ReactNode | undefined => {
        if (isKolInfoLocked && !showMockData) {
          return (
            <Percentage>
              <Blur activate>
                {formatNumber(FAKE_MAIN_GENDER, {
                  isPercentageDisplay: true,
                })}
              </Blur>
            </Percentage>
          )
        }

        return kpi?.audience?.mainGender?.weight ? (
          <Percentage>
            {formatNumber(kpi.audience.mainGender.weight, {
              isPercentageDisplay: true,
            })}
          </Percentage>
        ) : undefined
      })()}
      title={formatMessage({ id: 'kol:audience_analysis_gender' })}
      value={
        kpi?.audience?.mainGender?.code
          ? formatMessage({
              id:
                kpi.audience.mainGender.code === 'male'
                  ? 'kol:audience_analysis_gender_male'
                  : 'kol:audience_analysis_gender_female',
            })
          : 'noData'
      }
    />
  )
}

export default AudienceGenderStatistic
